import {
  ActionButton,
  ActionGrid,
  MiniNotice,
} from "./UI";

/* -------------------------------------------------------------------------- */
/*                            LEVEL 1 - PRIMARY                               */
/* -------------------------------------------------------------------------- */

export function PrimaryActions({
  onContact,
  onNoAnswer,
  onNotInterested,
  onWrongNumber,
  updating,
}) {
  return (
    <ActionGrid>
      <ActionButton
        onClick={onContact}
        disabled={updating}
      >
        Called
      </ActionButton>

      <ActionButton
        onClick={onNoAnswer}
        disabled={updating}
      >
        No Answer
      </ActionButton>

      <ActionButton
        onClick={onNotInterested}
      >
        Not Interested
      </ActionButton>

      <ActionButton
        onClick={onWrongNumber}
      >
        Wrong Number
      </ActionButton>
    </ActionGrid>
  );
}

/* -------------------------------------------------------------------------- */
/*                         LEVEL 1 - CONTACT MADE                             */
/* -------------------------------------------------------------------------- */

export function ContactedActions({
  lead,
  onTransfer,
  onFollowup,
  onCustomerCallback,
  onNotInterested,
}) {
  return (
    <>
      <MiniNotice>
        Contact made with{" "}
        <strong>
          {lead.leadDetails?.name}
        </strong>
      </MiniNotice>

      <ActionGrid>
        <ActionButton
          onClick={onTransfer}
        >
          Send to L2
        </ActionButton>

        <ActionButton
          onClick={onFollowup}
        >
          Follow Up Later
        </ActionButton>

        <ActionButton
          onClick={onCustomerCallback}
        >
          Customer Will Call Back
        </ActionButton>

        <ActionButton
          onClick={onNotInterested}
        >
          Not Interested
        </ActionButton>
      </ActionGrid>
    </>
  );
}

/* -------------------------------------------------------------------------- */
/*                           RETRY / QUIET                                    */
/* -------------------------------------------------------------------------- */

export function QuietActions({
  lead,
  retryCount,
  onContact,
  onNoAnswer,
  onCustomerCallback,
  onWrongNumber,
  onNotInterested,
  updating,
}) {
  return (
    <>
      <div className="mb-3 rounded-xl bg-amber-50 px-3 py-2.5">
        <div className="flex items-center justify-between gap-3">
          <div>
            <p className="text-sm font-semibold text-amber-900">
              Waiting for Contact
            </p>

            <p className="mt-1 text-xs text-amber-700">
              Owner:{" "}
              <strong>
                {lead.assignedTo}
              </strong>
            </p>
          </div>

          <span className="rounded-full bg-white px-2.5 py-1 text-xs font-bold text-amber-700">
            {retryCount}/4
          </span>
        </div>
      </div>

      <ActionGrid>
        <ActionButton
          onClick={onContact}
          disabled={updating}
        >
          Contact Made
        </ActionButton>

        <ActionButton
          onClick={onNoAnswer}
          disabled={updating}
        >
          Still No Answer
        </ActionButton>

        <ActionButton
          onClick={onCustomerCallback}
        >
          Customer Will Call Back
        </ActionButton>

        <ActionButton
          onClick={onWrongNumber}
        >
          Wrong Number
        </ActionButton>

        <ActionButton
          full
          onClick={onNotInterested}
        >
          Not Interested
        </ActionButton>
      </ActionGrid>
    </>
  );
}

/* -------------------------------------------------------------------------- */
/*                          FOLLOW-UP DUE                                     */
/* -------------------------------------------------------------------------- */

export function FollowupDueActions({
  followupAt,
  formatDate,
  onContact,
  onNoAnswer,
  onNotInterested,
  onCustomerCallback,
  updating,
}) {
  return (
    <>
      <MiniNotice>
        Follow-up scheduled for{" "}
        <strong>
          {formatDate(followupAt)} IST
        </strong>
      </MiniNotice>

      <ActionGrid>
        <ActionButton
          onClick={onContact}
          disabled={updating}
        >
          Contact Made
        </ActionButton>

        <ActionButton
          onClick={onNoAnswer}
          disabled={updating}
        >
          Not Answered
        </ActionButton>

        <ActionButton
          onClick={onCustomerCallback}
        >
          Customer Will Call Back
        </ActionButton>

        <ActionButton
          onClick={onNotInterested}
        >
          Not Interested
        </ActionButton>
      </ActionGrid>
    </>
  );
}

/* -------------------------------------------------------------------------- */
/*                       FOLLOW-UP COMPLETED                                  */
/* -------------------------------------------------------------------------- */

export function FollowupCompletedActions({
  onAnotherFollowup,
  onNoAnswer,
  onNotInterested,
  onCustomerCallback,
  updating,
}) {
  return (
    <>
      <MiniNotice>
        Follow-up contact completed.
      </MiniNotice>

      <ActionGrid>
        <ActionButton
          onClick={onAnotherFollowup}
        >
          Need Another Follow Up
        </ActionButton>

        <ActionButton
          onClick={onNoAnswer}
          disabled={updating}
        >
          Not Answered
        </ActionButton>

        <ActionButton
          onClick={onCustomerCallback}
        >
          Customer Will Call Back
        </ActionButton>

        <ActionButton
          onClick={onNotInterested}
        >
          Not Interested
        </ActionButton>
      </ActionGrid>
    </>
  );
}

/* -------------------------------------------------------------------------- */
/*                            LEVEL 2                                         */
/* -------------------------------------------------------------------------- */

export function L2Actions({
  lead,
  retryCount,
  onBooked,
  onFollowup,
  onNoAnswer,
  onCustomerCallback,
  onNotInterested,
  updating,
}) {
  return (
    <>
      <div className="mb-3 rounded-xl bg-slate-50 px-3 py-2.5">
        <div className="flex items-center justify-between gap-3">
          <div>
            <p className="text-xs text-slate-400">
              Level 2 Owner
            </p>

            <p className="text-sm font-semibold text-slate-800">
              {lead.assignedTo}
            </p>
          </div>

          <span className="rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-slate-500">
            Retry {retryCount}/4
          </span>
        </div>
      </div>

      <ActionGrid>
        <ActionButton
          onClick={onBooked}
        >
          Booked
        </ActionButton>

        <ActionButton
          onClick={onFollowup}
        >
          Need Follow Up
        </ActionButton>

        <ActionButton
          onClick={onNoAnswer}
          disabled={updating}
        >
          No Answer
        </ActionButton>

        <ActionButton
          onClick={onCustomerCallback}
        >
          Customer Will Call Back
        </ActionButton>

        <ActionButton
          full
          onClick={onNotInterested}
        >
          Not Interested
        </ActionButton>
      </ActionGrid>
    </>
  );
}